const labels = [
    'Law Enforcement',
    'Fire/Rescue',
    'Towing and Recovery',
    'EMS',
    'Transportation/PW',
    'Other Disciplines',
];

const data = {
    labels: labels,
    datasets: [
        {
            label: 'Trained',
            backgroundColor: 'rgb(1, 51, 160)',
            borderColor: 'rgb(1, 51, 160)',
            data: [7669, 884, 786, 2512, 1943, 1142],
        },
        {
            label: 'Total to be trained',
            backgroundColor: 'rgb(248, 140, 42)',
            borderColor: 'rgb(248, 140, 42)',
            data: [12842, 10248, 1577, 4485, 1365, 3704],
        }
    ]
};

const config = {
    type: 'bar',
    data: data,
    options: {
        plugins: {
            title: {
                display: true,
                text: 'TIM Training Progress'
            }
        },
        indexAxis: 'y',
        scales: {
            y: {
                stacked: true
            }
        }
    }
};

const myChart = new Chart(
document.getElementById('myChart'),
config
);
